import { render, staticRenderFns } from "./contact-list-item.vue?vue&type=template&id=f20a877a"
import script from "./contact-list-item.vue?vue&type=script&lang=js"
export * from "./contact-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports